import { ChevronDown, ChevronRight } from 'react-feather';
import SideEnds from '../orderSections/SideEnds';

const OrderSidesEndsSection = ({
	sections,
	toggleSection,
	onSelectionsChange,
	selectedStyle,
	formAdditionalOptionsData,
	setLeftLean,
	setRightLean,
	setFrontLean,
	setBackLean,
	leftLean,
	rightLean,
	frontLean,
	backLean,
	gableEndsOptions,
	sidewallOptions,
	windBracingOptions,
	jTrimOptions,
	leanRoofPitch,
	onDataChange,
	cSWidth,
	cSLength,
	cSHeight,
	lLWidth,
	lLLength,
	lLHeight,
	bLHeight,
	bLWidth,
	bLLength,
	fLLength,
	fLWidth,
	fLHeight,
	rLWidth,
	rLLength,
	rLHeight,
	control,
	sidewallCosts,
	setSidewallCosts,
	sideEndData,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('sideTab', e)}
				>
					<h2 className="title-h2">Sides & ends</h2>
					<button>
						{sections.sideTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.sideTab && (
					<SideEnds
						onSelectionsChange={onSelectionsChange}
						selectedStyle={selectedStyle}
						formAdditionalOptionsData={formAdditionalOptionsData}
						setLeftLean={setLeftLean}
						setRightLean={setRightLean}
						setFrontLean={setFrontLean}
						setBackLean={setBackLean}
						leftLean={leftLean}
						rightLean={rightLean}
						frontLean={frontLean}
						backLean={backLean}
						gableEndsOptions={gableEndsOptions}
						sidewallOptions={sidewallOptions}
						windBracingOptions={windBracingOptions}
						jTrimOptions={jTrimOptions}
						leanRoofPitch={leanRoofPitch}
						onDataChange={onDataChange}
						cSWidth={cSWidth}
						cSLength={cSLength}
						cSHeight={cSHeight}
						lLWidth={lLWidth}
						lLLength={lLLength}
						lLHeight={lLHeight}
						bLHeight={bLHeight}
						bLWidth={bLWidth}
						bLLength={bLLength}
						fLLength={fLLength}
						fLWidth={fLWidth}
						fLHeight={fLHeight}
						rLWidth={rLWidth}
						rLLength={rLLength}
						rLHeight={rLHeight}
						control={control}
						sidewallCosts={sidewallCosts}
						setSidewallCosts={setSidewallCosts}
						sideEndData={sideEndData}
					/>
				)}
			</div>
		</div>
	);
};

export default OrderSidesEndsSection;
